import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { CustomFieldValueComponent } from './custom-field-value.component';
import {
  DatePickerModule,
  TextInputModule,
  NumberInputModule,
  TextareaModule,
  SelectModule,
} from '@certemy/ui-components';

@NgModule({
  imports: [CertemyCommonModule, DatePickerModule, TextInputModule, NumberInputModule, TextareaModule, SelectModule],
  declarations: [CustomFieldValueComponent],
  exports: [CustomFieldValueComponent],
})
export class CustomFieldValueModule {}
